import {CalendarRegularPenIcon} from 'shells/icon/svg/calendar-regular-pen-icon';
import {ChatBubbleDoubleRegularIcon} from 'shells/icon/svg/chat-bubble-double-regular-icon';
import {ChatRegularIcon} from 'shells/icon/svg/chat-regular-icon';
import {EnvelopeNewIcon} from 'shells/icon/svg/envelope-new-icon';
import {PhoneOutlineIcon} from 'shells/icon/svg/phone-outline-icon';
import {QuoteRegularIcon} from 'shells/icon/svg/quote-regular-icon';

export const CHAT_ACTION = 'CHAT_ACTION';
export const BOOKING_ACTION = 'BOOKING_ACTION';
export const EMAIL_ACTION = 'EMAIL_ACTION';
export const CALL_ACTION = 'CALL_ACTION';
export const TEXT_ACTION = 'TEXT_ACTION';
export const QUOTE_ACTION = 'QUOTE_ACTION';

export const ACTION_CONFIG = {
    CHAT_ACTION: {
        action: 'CHAT_ACTION',
        label: 'Chat',
        icon: ChatBubbleDoubleRegularIcon,
        fragmentKey: 'chat',
    },
    BOOKING_ACTION: {
        action: 'BOOKING_ACTION',
        label: 'Book',
        icon: CalendarRegularPenIcon,
        fragmentKey: 'booking',
    },
    EMAIL_ACTION: {
        action: 'EMAIL_ACTION',
        label: 'Email',
        icon: EnvelopeNewIcon,
        fragmentKey: 'email',
    },
    CALL_ACTION: {
        action: 'CALL_ACTION',
        label: 'Call',
        icon: PhoneOutlineIcon,
        fragmentKey: 'call',
    },
    TEXT_ACTION: {
        action: 'TEXT_ACTION',
        label: 'Text',
        icon: ChatRegularIcon,
        fragmentKey: 'text',
    },
    QUOTE_ACTION: {
        action: 'QUOTE_ACTION',
        label: 'Quote',
        icon: QuoteRegularIcon,
        fragmentKey: 'quote',
    },
} as const;

export const DEFAULT_SUGGESTIONS = [
    'Can I see a demo or try it free before buying?',
    'What is your pricing like?',
    'Can you give me a quote?',
] as const;
